import React from "react";
import { Col, message, Row } from "antd";
import { useSelector } from "react-redux";
import {
  DEVELOPER,
  SUPER_ADMIN,
  SUPER_ADMIN_EDITOR,
} from "../../../config/roles";
import { BsCheck } from "react-icons/bs";

const ProfileButtons = ({
  profiles,
  setProfileManagementModal,
  selectedProfileId,
}) => {
  const { subscribedPlan } = useSelector((state) => state.membership);
  const { role } = useSelector((state) => state.auth.user);

  const profile1 = profiles.find((item) => item.profileIndex === 0);
  const profile2 = profiles.find((item) => item.profileIndex === 1);
  const profile3 = profiles.find((item) => item.profileIndex === 2);
  const profile4 = profiles.find((item) => item.profileIndex === 3);

  const handleProfileManagementModal = (index) => {
    if (
      subscribedPlan?.paymentStatus === "SUCCESS" ||
      role === SUPER_ADMIN ||
      role === SUPER_ADMIN_EDITOR ||
      role === DEVELOPER
    ) {
      setProfileManagementModal(index);
    } else {
      message.error("This is premium feature, buy subscription");
    }
  };
  return (
    <Col
      style={{
        marginLeft: "2rem",
      }}
    >
      <Row>
        <Col>
          <div
            onClick={() => {
              handleProfileManagementModal("0");
            }}
            className="profile_buttons"
            style={{
              backgroundColor: profile1?.profileButtonColor || "#a5be00",
            }}
          >
            <div
              style={{
                width: "25%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {profile1?.key === selectedProfileId && (
                <BsCheck style={{ fontSize: "2rem", color: "white" }} />
              )}
            </div>

            <div
              style={{
                width: "75%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p className="profile_buttons_text">
                {profile1?.profileName || "Profile 1"}
              </p>
            </div>
          </div>
        </Col>
        <Col>
          <div
            onClick={() => {
              handleProfileManagementModal("1");
            }}
            className="profile_buttons"
            style={{
              backgroundColor: profile2?.profileButtonColor || "#9c7178",
            }}
          >
            {profile2?.key === selectedProfileId && (
              <div
                style={{
                  width: "25%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <BsCheck style={{ fontSize: "2rem", color: "white" }} />
              </div>
            )}
            <div
              style={{
                width: "75%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p className="profile_buttons_text">
                {profile2?.profileName || "Profile 2"}
              </p>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <div
            onClick={() => {
              handleProfileManagementModal("2");
            }}
            className="profile_buttons"
            style={{
              backgroundColor: profile3?.profileButtonColor || "#20063b",
            }}
          >
            {profile3?.key === selectedProfileId && (
              <div
                style={{
                  width: "25%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <BsCheck style={{ fontSize: "2rem", color: "white" }} />
              </div>
            )}
            <div
              style={{
                width: "75%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p className="profile_buttons_text">
                {profile3?.profileName || "Profile 3"}
              </p>
            </div>
          </div>
        </Col>
        <Col>
          <div
            onClick={() => {
              handleProfileManagementModal("3");
            }}
            className="profile_buttons"
            style={{
              backgroundColor: profile4?.profileButtonColor || "#cc3363",
            }}
          >
            {profile4?.key === selectedProfileId && (
              <div
                style={{
                  width: "25%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <BsCheck style={{ fontSize: "2rem", color: "white" }} />
              </div>
            )}
            <div
              style={{
                width: "75%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p className="profile_buttons_text">
                {profile4?.profileName || "Profile 4"}
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );
};

export default ProfileButtons;
